import React from "react";
import { useTranslation } from "react-i18next";

const LoadingPage = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen w-full py-20 relative flex md:flex-row flex-col gap-10 justify-center items-center bg-white">
      <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white flex flex-col items-center justify-center">
        <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-700 h-12 w-12 mb-4"></div>
        <h2 className="text-center text-gray-800 text-xl font-semibold">{t("loading")}</h2>
        <p className="w-full text-center text-gray-800">{t("loadingDescription")}</p>
      </div>
    </div>
  );
};

export default LoadingPage;